"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryTriggersWithTriggerId = exports.queryTriggersWithPositions = exports.queryTriggersWithOrderId = exports.modifyTrackOrder = exports.modifyTriggerOrder = exports.createTriggerOrder = exports.deleteTriggerOrder = exports.queryHistoryTriggers = exports.queryAllTriggers = exports.queryActiveTriggers = void 0;
const operators_1 = require("rxjs/operators");
const utils_1 = require("./utils");
/**查询当前活跃的普通条件单 */
function queryActiveTriggers(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/open_triggers",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "triggers")));
}
exports.queryActiveTriggers = queryActiveTriggers;
/**查询所有的条件单（止盈止损/追踪出场） */
function queryAllTriggers(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/all_triggers",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "triggers")));
}
exports.queryAllTriggers = queryAllTriggers;
/**查询历史条件单 */
function queryHistoryTriggers(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/closed_triggers",
        method: "GET",
        query: params,
    }).pipe((0, operators_1.map)((resp) => (0, utils_1.processPageCursorData)(resp, "triggers")));
}
exports.queryHistoryTriggers = queryHistoryTriggers;
/**取消条件单 */
function deleteTriggerOrder(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: `/trigger/${params.triggerId}`,
        method: "DELETE",
        query: params,
    });
}
exports.deleteTriggerOrder = deleteTriggerOrder;
/** 创建条件单 */
function createTriggerOrder(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trigger",
        method: "POST",
        data: params,
    });
}
exports.createTriggerOrder = createTriggerOrder;
/** 编辑条件单 */
function modifyTriggerOrder(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trigger/modify",
        method: "POST",
        data: params,
    });
}
exports.modifyTriggerOrder = modifyTriggerOrder;
/** 编辑回撤单 */
function modifyTrackOrder(params) {
    return modifyTriggerOrder(params);
}
exports.modifyTrackOrder = modifyTrackOrder;
/**查询绑定订单的条件单 */
function queryTriggersWithOrderId({ accountType, order_ids, trigger_function = "ORDER,TRIGGER" }) {
    return (0, utils_1.requestWithSignV2)({
        accountType,
        api: "/trigger/orders",
        method: "POST",
        data: { order_ids, trigger_function },
    }).pipe((0, operators_1.map)((res) => res.triggers || []));
}
exports.queryTriggersWithOrderId = queryTriggersWithOrderId;
/**
 * 查询绑定仓位的条件单
 * 包括止盈止 + 追踪出场
 */
function queryTriggersWithPositions({ accountType, positionIds, triggerFunction = "POSITION,ORDER,TRIGGER", }) {
    return (0, utils_1.requestWithSignV2)({
        accountType,
        api: "/trigger/positions",
        method: "POST",
        data: { position_ids: positionIds, trigger_function: triggerFunction },
    }).pipe((0, operators_1.map)((res) => res.triggers || []));
}
exports.queryTriggersWithPositions = queryTriggersWithPositions;
/**按条件单查询条件单 */
function queryTriggersWithTriggerId({ accountType, trigger_ids }) {
    return (0, utils_1.requestWithSignV2)({
        accountType,
        api: "/trigger/trigger",
        method: "POST",
        data: { trigger_ids },
    }).pipe((0, operators_1.map)((res) => res.triggers || []));
}
exports.queryTriggersWithTriggerId = queryTriggersWithTriggerId;
